// @flow

export const APP_NAME = 'Dish Anywhere';
export const COMSCORE_PARTNER_ID = '17817715';
export const MILLIS_IN_SECOND = 1000;
export const SECONDS_IN_MINUTE = 60;
export const AD_BREAK_TYPE_PREROLL = 'PREROLL';
export const AD_BREAK_TYPE_MIDROLL = 'MIDROLL';
export const AD_BREAK_TYPE_POSTROLL = 'POSTROLL';
export const AD_BREAK_TYPE_LIVE = 'LIVE';
export const ADS_DELIVERY_SERVICE = 'Freewheel';
export const DEFAULT_CDN = 'Level3';
export const DEFAULT_FRAMES_RATE = 30;
export const DEFAULT_RETRY_COUNT = 4;
export const AD_LOAD_CONST = '2'; // same as mobile value
export const BITES_IN_KB = 1000;
export const EMPTY_STRING = '';
